import executeWhenFinishToRender from 'core/renders/executeWhenFinishToRender'
import agentStore from 'utils/store/simple'
import store from 'utils/store/withMiddleware'

function addAgencyIdAndExecuteFinishToRender() {
  const agentInformation = agentStore.getState()
  const state = store.getState()
  state.hcStorage.agency_id = agentInformation.agency_id
  store.update(state, true)
  executeWhenFinishToRender(state.hcStorage)

  return state
}
export default addAgencyIdAndExecuteFinishToRender
